import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import Table from "react-bootstrap/Table";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Header from "../../Header/Header";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import ModalSave from "../../common/ModelSave";
import { Context } from "../../../utils/context";
import { putData } from "../../../utils/api";
import { formatDate, formatDateToIST, IDS } from "../../../utils/common";

library.add(fas);

const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

const STATUS_CLASS = {
  pending: "bg-warning text-dark",
  approved: "bg-success",
  rejected: "bg-danger",
};

const DOCS = [
  ["aadhar_front", "Aadhar Card - Front"],
  ["aadhar_back", "Aadhar Card - Back"],
  ["pan_image", "PAN Card"],
  ["bank_proof_image", "Passbook / Cheque Book"],
  ["photo", "Passport Size Photo"],
];

const isPdf = (p) => /\.pdf$/i.test(p || "");

const Kyc = () => {
  const { getData, Per_Page_Dropdown, isAllow, IMG_URL } = useContext(Context);

  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const [option, setOption] = useState();
  const [perPage, setperPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [onPageChange, setonPageChange] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [reset, setReset] = useState(false);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const [selected, setSelected] = useState(null);
  const [rejecting, setRejecting] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    register: registerFilter,
    handleSubmit: handleFilterSubmit,
    reset: resetFilter,
    formState: { errors: filterErrors },
  } = useForm({ defaultValues: { search: "" } });

  const {
    register: registerReject,
    handleSubmit: handleRejectSubmit,
    reset: resetReject,
    watch: watchReject,
    formState: { errors: rejectErrors },
  } = useForm({ defaultValues: { reason: "" } });

  const reasonValue = watchReject("reason") || "";

  const getDataAll = async () => {
    setLoader(true);
    const response = await getData(
      `/admin/kyc?page=${onPageChange || 1}&per_page=${perPage || 5}&term=${encodeURIComponent(
        search || "",
      )}&status=${status || ""}`,
    );
    if (response?.success) {
      setLoader(false);
    }
    setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [perPage, reset, onPageChange, status]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const handleClose = () => {
    setSelected(null);
    setRejecting(false);
    resetReject({ reason: "" });
    setError("");
  };

  const review = async (action, formData = {}) => {
    setError("");
    setBusy(true);
    const response = await putData(`/admin/kyc/${selected.id}/${action}`, {
      reason: (formData.reason || "").trim(),
    });
    setBusy(false);

    if (response?.success) {
      handleClose();
      setShowModal({ code: response.code, message: response.message });
    } else {
      const errors = response?.errors;
      setError(
        typeof errors === "string"
          ? errors
          : Object.values(errors || {})[0]?.msg || "Something went wrong",
      );
      return;
    }
    setTimeout(() => setShowModal({ code: 0, message: "" }), 1000);
    getDataAll();
  };

  const onSearch = (formData) => {
    setSearch(formData.search.trim());
    setonPageChange(1);
    setReset(!reset);
  };

  const canReview =
    selected?.status === "pending" && isAllow?.includes(IDS.Customer.Edit);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"KYC Verification"} link={"/admin/kyc"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0 p-2">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  <div className="row p-2">
                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="">
                          <div className=" top-showing-wrapper  sowing ms-3 me-2">
                            <p className="show m-0">Show</p>
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            <p className="show m-0">
                              Entries{" "}
                              {`Showing ${Math.min(
                                (currentPage - 1) * perPage + 1,
                              )} to ${Math.min(
                                currentPage * perPage,
                                data?.data?.total,
                              )} of ${data?.data?.total} entries`}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12">
                        <div className="row align-items-end mb-3">
                          <div className="col-12 mb-2">
                            <form
                              className="row p-2"
                              onSubmit={handleFilterSubmit(onSearch)}
                              noValidate
                            >
                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">
                                    Name / Contact / Unique Id
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      filterErrors.search ? "is-invalid" : ""
                                    }`}
                                    placeholder="Search Customer"
                                    maxLength={50}
                                    {...registerFilter("search", {
                                      maxLength: {
                                        value: 50,
                                        message:
                                          "Maximum 50 characters allowed",
                                      },
                                      pattern: {
                                        value: /^[a-zA-Z0-9\s@._-]*$/,
                                        message:
                                          "Special characters are not allowed",
                                      },
                                    })}
                                  />
                                  {filterErrors.search && (
                                    <div className="invalid-feedback d-block">
                                      {filterErrors.search.message}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">Status</label>
                                  <select
                                    className="form-select"
                                    value={status}
                                    onChange={(e) => {
                                      setonPageChange(1);
                                      setStatus(e.target.value);
                                    }}
                                  >
                                    {STATUS_OPTIONS.map((s) => (
                                      <option key={s.value} value={s.value}>
                                        {s.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end ">
                                <div className="Search me-2">
                                  <Button
                                    type="submit"
                                    className="btn btn-search"
                                  >
                                    Search
                                  </Button>
                                </div>
                                <div className="Search-1">
                                  <div>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        resetFilter({ search: "" });
                                        setSearch("");
                                        setStatus("");
                                        setonPageChange(1);
                                        setReset(!reset);
                                      }}
                                      className="btn btn-reset"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3 p-2">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr className="">
                            <th className="sr" style={{ width: "8%" }}>
                              Sr. No.
                            </th>
                            <th className="tax-name">Name</th>
                            <th className="tax-name">Contact No</th>
                            <th className="tax-name">Unique Id</th>
                            <th className="tax-name">Submitted On</th>
                            <th className="tax-name">Status</th>
                            <th className="active">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loader ? (
                            <tr>
                              <td colSpan="7" className="text-center py-4">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            data?.data?.data?.map((d, index) => {
                              const paginatedIndex =
                                (onPageChange - 1) * perPage + index + 1;
                              return (
                                <tr className="" key={d?.id}>
                                  <td>{paginatedIndex}.</td>
                                  <td>{d?.User?.name || "-"}</td>
                                  <td>{d?.User?.contact_no || "-"}</td>
                                  <td>{d?.User?.user_uid || "-"}</td>
                                  <td>{formatDateToIST(d?.createdAt)}</td>
                                  <td>
                                    <span
                                      className={`badge ${STATUS_CLASS[d?.status]}`}
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {d?.status}
                                    </span>
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      <Button
                                        type="button"
                                        className="btn btn-primary me-1"
                                        onClick={() => setSelected(d)}
                                      >
                                        <FontAwesomeIcon icon="fa-solid fa-eye" />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Modal
        show={!!selected}
        onHide={handleClose}
        size="lg"
        centered
        scrollable
        className="userdeatailspp"
      >
        <Modal.Header closeButton>
          <Modal.Title>KYC Details - {selected?.User?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <div className="row">
                {[
                  ["Full Name", selected.full_name],
                  ["Contact No", selected.User?.contact_no],
                  ["Address", selected.address],
                  ["Pin Code", selected.pincode],
                  ["Aadhar Number", selected.aadhar_no],
                  ["PAN Number", selected.pan_no],
                  ["Bank Account Number", selected.bank_account_no],
                  ["IFSC Code", selected.ifsc],
                  ["Branch Address", selected.branch_address],
                  ["Submitted On", formatDate(selected.createdAt, true)],
                ].map(([label, value]) => (
                  <div className="col-lg-6 col-md-6 mb-3" key={label}>
                    <div
                      className="text-muted"
                      style={{ fontSize: 13, marginBottom: 2 }}
                    >
                      {label}
                    </div>
                    <div
                      className="fw-semibold"
                      style={{ wordBreak: "break-word" }}
                    >
                      {value || "-"}
                    </div>
                  </div>
                ))}
              </div>

              <hr className="mt-1" />

              <div className="row">
                {DOCS.map(([key, label]) => (
                  <div className="col-lg-4 col-md-6 mb-3" key={key}>
                    <div
                      className="fw-semibold"
                      style={{ fontSize: 14, marginBottom: 6 }}
                    >
                      {label}
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        height: 140,
                        border: "1px solid #dee2e6",
                        borderRadius: 6,
                        overflow: "hidden",
                        background: "#f8f9fa",
                      }}
                    >
                      {selected[key] ? (
                        <a
                          href={IMG_URL + selected[key]}
                          target="_blank"
                          rel="noreferrer"
                          className="d-flex align-items-center justify-content-center w-100 h-100"
                        >
                          {isPdf(selected[key]) ? (
                            "View PDF"
                          ) : (
                            <img
                              src={IMG_URL + selected[key]}
                              alt={label}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </a>
                      ) : (
                        <span className="text-muted">Not uploaded</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {selected.status !== "pending" && (
                <p className="mb-0">
                  <strong>Status:</strong>{" "}
                  <span
                    className={`badge ${STATUS_CLASS[selected.status]}`}
                    style={{ textTransform: "capitalize" }}
                  >
                    {selected.status}
                  </span>
                  {selected.status === "rejected" && selected.reject_reason
                    ? ` - ${selected.reject_reason}`
                    : ""}
                </p>
              )}

              {canReview && rejecting && (
                <div className="mt-3">
                  <label className="form-label">Reason for rejection</label>
                  <textarea
                    className={`form-control ${
                      rejectErrors.reason ? "is-invalid" : ""
                    }`}
                    rows={3}
                    maxLength={250}
                    placeholder="Reason shown to the user"
                    {...registerReject("reason", {
                      required: "Rejection reason is required",
                      validate: (v) =>
                        v.trim().length >= 3 ||
                        "Reason must be at least 3 characters",
                      maxLength: {
                        value: 250,
                        message: "Maximum 250 characters allowed",
                      },
                    })}
                  />
                  <div className="d-flex justify-content-between mt-1">
                    <span className="text-danger" style={{ fontSize: 13 }}>
                      {rejectErrors.reason?.message}
                    </span>
                    <span className="text-muted" style={{ fontSize: 13 }}>
                      {reasonValue.length}/250
                    </span>
                  </div>
                </div>
              )}
              {error && <p className="text-danger mt-2 mb-0">{error}</p>}
            </>
          )}
        </Modal.Body>
        {canReview && (
          <Modal.Footer>
            {rejecting ? (
              <>
                <Button variant="secondary" onClick={() => setRejecting(false)}>
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  disabled={busy}
                  onClick={handleRejectSubmit((d) => review("reject", d))}
                >
                  Confirm Reject
                </Button>
              </>
            ) : (
              <>
                <Button variant="danger" onClick={() => setRejecting(true)}>
                  Reject
                </Button>
                <Button
                  variant="success"
                  disabled={busy}
                  onClick={() => review("approve")}
                >
                  Approve
                </Button>
              </>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default Kyc;
